import { Injectable } from "@angular/core";
import { Relatorio } from "app/models/Relatorio";
import { format } from "date-fns";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { FormatPdf } from "./format-pdf";

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
(<any>pdfMake).fonts = {

    // Zilla: {
    //   normal: 'https://fonts.googleapis.com/css2?family=Zilla+Slab&display=swap',
    //   bold: 'https://fonts.googleapis.com/css2?family=Zilla+Slab:wght@700&display=swap',
    // },

    // // download default Roboto font from cdnjs.com
    Roboto: {
        // normal: 'https://cdn.jsdelivr.net/npm/@typopro/web-zilla-slab@3.7.5/TypoPRO-ZillaSlab-Regular.ttf',
        normal: 'https://cdn.jsdelivr.net/npm/@typopro/web-zilla-slab@3.7.5/TypoPRO-ZillaSlab-Medium.ttf',
        bold: 'https://cdn.jsdelivr.net/npm/@typopro/web-zilla-slab@3.7.5/TypoPRO-ZillaSlab-Bold.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    },

    // // example of usage fonts in collection
    // PingFangSC: {
    //   normal: ['https://example.com/fonts/pingfang.ttc', 'PingFangSC-Regular'],
    //   bold: ['https://example.com/fonts/pingfang.ttc', 'PingFangSC-Semibold'],
    // }
}

@Injectable({
    providedIn: 'root'
})
export class PdfChatbot {

    constructor(
        private formatPdf: FormatPdf 
    ) {

    }

    generatePdf(relatorio: Relatorio) {
        return new Promise((resolve, reject) => {

            const dd: any = {
                defaultStyle: {
                    font: 'Roboto'
                },
                content: [
                    /* ############ CABECALHO DO RELATORIO ####################### */
                    {
                        marginTop: -59,
                        table: {
                                widths: ['auto'],
                                body: [[{
                                    text: "___________________",
                                    color: '#fff',
                                    borderColor: ['#009B45', '#009B45', '#009B45', '#009B45']
                                }], [" "]]
                        },
                        layout: {
                            hLineWidth: function(i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 10;
                            },
                            vLineWidth: function(i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        columns: [
                            {
                                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAAAwCAYAAAAhFIlJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABVvSURBVHgB7VwJeBRVuj23qro7zRYIq0GEQIQQRFmEkUHehATCMgpPnCCjoCAI4jbuPB30tTKgPnWccQGBPBfeuAyMDm6AIYTIjgMIGkJQwKCBQFiSCGTp7qr7zq1uIEBnI7L4TZ/vq3R13a363lP/eisCPwc88U60bNUcLlckTG9TaIYBS4pTK1kWhFUC0/gJfm8e7s48ijB+URCoC15LaAWncQOEdi0kYiFkK35ewhJHJS2KOOQ+fu7gyN+QPItwVfv1uHqOD2Fc9Kg1WTxZaIBseD2FA9zQtNsg5TXspS1J0pyfTVilWc16kiSIKGT7reznbfi8X2A/8uDJ9COMixK1IsuMFegrDdzsK8dLnv6UDsfxRr/mkM5Y+LQO0NGLvfbg1e4kUP0adu0leTIgxUdo3PgNjFzgRRgXHWpElukrKDUcuBVCPCElJYuQN05dM2glGsrJ0JBLc2QTymUBHEWlyL++DG0zG8FrtIEhroeJW2zJgxoRx8sxMuDwT8GtGVRTpFsYFw306iqQKPGUJs8IIe7l1/pkl8ZFXJ+RsnM5hsXM5XJOJOcmwSGuhebuhPp5bph6GXD4O9yx6gtc1/4dSG03CeZiPaWiIqq5n1hY2kBsjN2Fnq5cZB4wEcZFAa2qwulfoptwincFxE386jx+nYTpGzzdEPw0SBpl5D4IzXqXS74QImoeUgfcTG74MCntDQj9FkhrDFunozoEjOXZaB19F+bHOxHGRYFK1dCMtRhBX/clVrjszFKZJSRueDwr+Wou6nuoGvupWj6DnwRyeVdiXGYRUpNH0bWexLYknXBU0dYHC1Ph980Mu9oXHiHV0Iw1iCVRXhECcaHKpR00wdrlBe2ySITxqNxVVmgAZexqciCkHo/rO7gxYel72Hz5KhKF48segc9K7k9DT2h6CcZEbMSCsEq6kDhjkaatRwylyQLaKD0qa0S11EATOLj3SFTGQX+9nrzUAdVC1OOfK3iMwKYOw+ky5/OgPYNNJJwiZYtKGro54DUob7wXn+zcjDAuGM60WUyKfSm6VdeQ0uXaoZd+6+OCL+HXMtQO3aCJ2STJXJLoIHubwA5XVVE/kjf2P3gjKR5hXDCckCx0iYUxCIM1IabzSXZU31Q0dzvK0zL2d9hG2yOZ35uidtA5TgcevyU5S2GJ10ldJaHaVjIeJZNohOSYFVj0fSnCOO84QRZjKGI0iWf5tHesYVuN2Z8DGcN3/R+Gxbbi9//A2SGgZjShVNRnPKeLHcqottGOd5yHT3ZtQhjnHbYa8kgG3CWGkij9atRKyoOSXhBV0ZyJGyiFdPNdLvJenD2Uodubn3dRyvxACbK1knqRvMfb4EkwEMZ5h02WiFW4lIt0PyrEUqpALiXKY/5SLqyJmHZe3D65xQYaq9ZzLCtB3dCax++g4jZCVmYH9UW0PhhhnHfYZPHqDKipyGm1kKuFX46SGpY5IjBN08QHUogXLo0qHkKbYyGN1M9RZ0gSVsZWGX/R9LuY8W6AMM4rhGc5DIcTf6fNMKKySlLlbKRc1MiPiUdcIDHwEptGnehEyn8ZBoY9+lVyY1oyq3kpCucU8gfGbMZj4ucho8GJcXiY7v00VJ1aUP08viwHz+BiwtyBgXyYlDMxMf1uXETQtAhcTqJUJVW8JMMsQ8OLRx14gxJkVkWiKFC6dPVbmOLpmLaPZXS9cY6jraI1GXotPB4NYZw3GLQse9JtjhYhAv/SXnT5Oo3XfFOKVFK+owidIoiwLDHW4ZIF8XvyXsyObq28o3tw7iQM3W7ZHZesasjz4tMLqcA+lKbcyvvXhIV6QrMN5wT+lq9pb73A33FY1dP82IYwagzlVcSK0IvqFZBfcHIjKdLv4vd6Ve1nINka88+U0QOytz6+NfrPPI/m5bHBMc4F2sPhCGmQL/sGu/ihDgxoj0haQSnqnCTJ1y0sW7r9VM9tUGdc4jMxQG2lILGENJFLOq7I2Ibdx+skxaGjtPArdV4usCxC4DqSsQUftuU+HVuEH7/i/KiH7oDFgyIvmQMeYyJjYXo2frD76Ihear+Pascyn67hK18pMjJzax3UDICxMcxKioHTSIRpXmpf04ztKPel4Z5lh86oPyepF3XJr2HKJnyMjnCNVECUmRvhg8+7DpN5J3MTW7KTQZQU7VhuUt3noFiuxCNpBSpb3JRDamfehyxQgTcmDIeEKq/k5iMtXcx6plv6mMc2D3iYg+7h1D/E9j+/MSqZtyrzKslyAHUASXCdTwoPSdKFZHKpBeB5Ge2yb5Pi5B9p03xqVxToITQxR526ITey2tUkhovztNcw8QAfqmFseSOLSzR7+yjJLOCXlrwh6XKM5yMziW3u4Hyqh87F+pIJtp+MCLkw8QpMychiwrU2mN3TgblR4+EQj7Gnplz84H4hsxwuLQuzkx5Bfr8vqKotu67eZBJNiKf5++qxrppAjeeBXJuUhdDd4zGzP2NcxkKoOJeQul1HWF6KgXWYnTBKBdaahLoXdteck9G7xkQ52S7aNDHTE5/OiG676RzwLxx4H35+GHA4W6AO6N8RV0ElTCXTD0L+KIScz8/3GUPKY3EXVdY/Dir3ZUe4ETCYI0iqDqyzjle/5/wVckoPs9QZLGvMyhQ+cj2vHSXx9lKaFHNhymj7lZJcaTzmsW2aCkAyYXuzbmIUagMP10SLGsj2z7MfFcD8lsffeL9/5+dPPFTy9WW0/bKLXd8Z1YXjq9CIerjogCjjX2SwrR74TZL5ObMADv1BnjNPp9aLtqkQr7CdkooxEBExGifKFfqOhAtnASmlMm7/6aYoxqQ5zB1F0NvQx/Haz28fWGYr1AG6wEP8aCc1mcuJ/0+zJUbzGOMDbiJpVJS4HR/Cqae3IyGmu3xIMQ2M5Nf7+XCcSHCSJHlcgXssA8OFJceSQQ9ROh0qaYJnKe+H1auPURk5GOt14PckzQoy0GEK3IjaoHVic9pgtyOQ0V8DXZuAPX1vQ2TkrfxRt7MslwsRB9M3HvOS61O+MePPBVek0jAFE9JmQGjKpgxKM7ER8OexTiDVIvndsjzI6/sIpOMmGNYoNG64yeCTUb9uW/yDE6iMYUndpuPpqddQbB3HpE9VoG4JXh6yHC5zGmczhQvRDhcYiTFoaQkxQP12PjAF1NxjtfxAmRKllKrHbB9WimsS4hn3sU62tVohdXGmbWfYKjBoFwUgkOtthRWZmVAbzz863sa7Fv4GcWhaegx/oOrrjsD7DK3tJpZog9rsINWc7fmgJPGMc679Fbd/TmLbIS4vpc4iRA8cxPu4k+vRjzItEi7htjWEhULWL7K3q77qL4RT0215qX5wnnUI0Y7l/HVsK7lG9JBbr1nER+pT7DY3wLPA/FmMT0qT7fx4lYbewqeuQV7ISvctLsebCU/Cb/AGND7RMpFX6+ECQRj2nuCgihV9SI4+FcsrLJ3abOOsuJSZmVUYpBJWkCgnkJAAQ+zH/VYgSh6NusLyqy2qje23IzRrzyllHlIiVe4myf12nQY+C/6IDWx0hL/2Si7WLUgd8DHLr2PtRlAEM/UseJb6MbvfPKobZcSrCHl3/pjukP4bEO18DfPjUxVZav3ODsnos9R+FOAbTuKrZh4yPCNR/Y78cZlqkjPtIzUhFtK4jzedRBarJ6shzidoR9DuOCqkaKnsCF55K2Q1ejRMPOyh5LgKZwnHPvSlbfIobLUhX9QN/DUtCz9SwjzG2ZyBWkOjJyPp0clIGrddMD9lHUYuCBirLw+hkW71IDlcwXe0aKwfWAq96TO8/qiKw3LOPcGOvBRrL8HpW2p/m7QyHykpKUgu7qbUMlXRCK5NB44zHUeivzYogotq+kKIRS+A9bN5mkmjbEt5IbZ5hp1lPmhC5g5a6vdT1LUl27vypvrwx5DVoifvp1H1HUgf6xXiLKHsiAFxWESy38vQQDv2l8tra1VZSjwaFHpxRWEkNm7cGHiYEuNw1uAqqg1lzSj9czQNCxRR7F9A50JUpn3UIs0dPPSM69LnxVHvBjR0rKAUG0Xb414UF6vXcjLscqdf7Q0azLnh/NAsqF9QgnHZPiZfn0dr5xh2wBCHsh+19Tz/CI3MdIwMblmdn+JkX3/gg/Q+xqU9idcHLuH5J/b7YBbaGz4nHhJlMlUz7ThCLI9TqMPvReTmDq0Ztuo+HPQ6GWZYgqMeT0UtfpZQbh3wvX38uc9SNGrkhk800v2lnTUh2nMe25zehLd3yHIZW2nI78be8u2oAxh1nqlrkiJXdOTivJcUz8m18ONhUwylr9Wy8RH5Jw8wy4O6/VYSYh+JUcqzGJOpksQ4+TnVXlc6WIlVNEuCNHufcVVj3OOBZb/GnIEqWNqXD5rydOYjdaCyE9280+6Bl/3kWi7euxiZHZD4l7mbwPTHBDoxpsDyboe/nDbXJYG9QSqTX/TTA7zZp+AXo6iq0uDQ4ildmOmnh2Vhv7FqDGLp7/9GBCzrZiw4faslgzToxIXrKQJu2SHW2ZXcGfu8LZFzun6uJTQqo2jdSUt99trL7PE1RCm3nQazO2QLQfdU0iin9MkX+C4bZ4/Mb7G9fzzGaJZ8hB0PZhxidHAMBNxJ6Otj4cAOlKMOYORjne6Wc6jyJnMe+1CSUYriCF11FctqUkkzA6HCGjIodScu/QKpQ5g78iv11pvXfxu892M8FtAOeRaT0r+2r72a1JSLrt7QUJHraNo8HzI4VwCneweKC9Mwd8jbmLAoD68nr+KoW0gYtS+6eyBeR49JYiaKStcY0o8rhS7+C9W8BBYUN4oYJWxcRNF61MhHPgNXWzgBG8r8+NJNbvbLQaGnkidReQ3OCLjLJLrSFuhlqTiOFG14T1EioHrqs29XlX6BDNwLg13vun/Cx0DVtpKDAbYyC9MpQWYyervPG40CnJRHcnk21id3wAN+Tc6mJasCadSwOMT7+4qL/MPi3ABRDB+WWQ7Zv7ox/JodkDsFjIsW0T6ZxnDoCrri6n1wv3rg6DIfNKRsfGqb0GOcHIyR1+PoULoYu/SttKy60DsKSGFLbEdD1ybc8llARS+nxNih3GnziUAjkcMHcics2YL3QCNW9GJZZ8z/3W2YvHQ13hw4mn0wtmRGq9gQRce/cFDPxqOrjwn+CMX0dyQQg7rAtn3kl2TJBxS76/bpyMnOthdSG9gJrRj+6UUJNlKopwCiBtshqoSXxuk0huOno1Y+578h5iW34Gwt4Swp72YODP8U+3Wc5QnADoci0NN2EE74+9l2ZBUwzDJ8pbnkLj7ZbTjreVzoMxJzZCC9JtEeqEQ1BOooVy6ZMeS+PJ/d4gD+u0U8ogw/7mM8YzhlTRsRiCBWCRqBXt4HXb9KDGfB2IRACftSOjpMlOpQ6rUYlzkUmCpxKSz35Xhz8AbklKktql0DKoNuttd/qLquahWPU2qEYrSN5UQ/SpCuHD9eLR4JRvdTMLcmlQkx1QFkUaTcTYmlooxnJCl52z7WVdHDArbdyptYQ8Mv23Lg28xsnIvUwL8v1DaO1mtGcNZfQOjN8AdVLdyx9LXqujpOFtvQZDwvytCgJIgyOpw8GmkSh0kQ2wah97CLkmJf2k7qfaJPH7jrFSPGMhFLq7gZndlVIgI3S5PWtLB36p8W9JMHeX011dHHTh1Z7G+ncmFVSQLdVQYGWvn8uNzQVc6EgTCL+l3HXl0GjGh+z2Pbw8u+C2SUw6ghlN2y23kVZ3FEIKQvA7sQpbWLScV0+vYbaAwXV9eNTZaEjmhGokyjsTmc6uikqpG2Re6v8F0Ze36l40igbfRK1tM9eq9tDooK4zDcjlkI0VvKipFZ6WW7Lex3vubEByVFKKKRW48EaM4EXHe6lCpRp+IsMWxnqIzs8eSlCEROTxqwFrwW7aLlObgeYdQebyVEoNjtRIQvICRc/nKMzazx9ogTkmVAPK7nk/uavQutZvDT9ZvHVX3JzyAQ3cIp7K1ZhZ5Vej6LZ2+TiB+qPR1M1bdnmP1aS+JGDnwlVddlArXKahdTfT2SnoO5COO847iasPwl+Fxz4T1ocoK6QPXDpALo3UElG+16QsU+pFA775W9kcryj6QUag/rb0gO23iVdvpAFggLz5MU79CrL2LQuX1iZ0ouS0xklQYimBOqaDCp96dJBCXFStVej5Dj2+PhQ4RxQXCKgTuI3ovfH3xZTKDYlFD5n2Z68F9/UZVcwdVrxUY5VCPruJjP8WJihd4oZOSHDGM9l/E1tiR2pMvMdL+mi8n2v9E4E0ql5bLOTpb/yPZ7OEYOdWhZyPENbDq+6yyM849KvaHkToihWoo0XDiyOIuLWQFUWd2lCYabRYVwtDxKm2I2nbBp6btQ3D8WgzQDT3KIX5/Zu6Q6wSKKkgWGiW0lLuxf9Y3tsp8I5jE2w0gjWoQaP4wLg1Bk0ZI6407aE3+i2jkRbpZSHvDpSHD5EUXDdAGbnth4xADZCnpEf2T4fFXf9rgswoUHefFOoMLGKkFfSb38rmGh6cS8zM2M9saiuUOgm6Whiy7sPayx0v5HPir9fqLdYbabXnIUs9bmIfyO8wVEqP0sFlXNPIahY/mY3yPsl72k2h74Av3ZFrQfnqtIFJVDYSdPpJEothqz8ILyqlDx7UYp80jLV6he/kFXOTfhSkTThvk9jeIhLO2hB/JPhh1hO42+vDaPZJoTJsqFR6VqyI6hHMYdrPEoK82lA/umdInFdiDuOKRcwvzJOOY+9vXvhL50p//CLq+u0HsRJdLfGDt5euUOHFA75HltNNXbw3Sx3VXdGG2fYtads09gajBtEMYFRnURXJ0L3NvUcMAwtelUNyNPFjEr60CKeu1iQBwS1AZfSoEKuz6kisPMsMrxD/XN4cZoC+IBXour3l22Vc9TJccwNyxRLh5UF+Mw1Yag+rralmAd4/dgql5uUAE4RZSkWMSTBE+dIIp6vUCSKMAU6xK8z0x0M0Z1n6SLPUNJpaqIotxnEnIzJc9oSqyw6rnIUO2/NlX4rgBlES2wuCFdWaFS+BamLt+O1YlX2LbGW5Qq/U6+qSg3Mr5yG8tXtnNS7ej4X9o9Y1D1Fgja0/brF2/SPrmLEdrNuUV12icTxjlArRKJKfFwFjJ/E4x1iMQ4zNAgHpSBsDwj8TLX1HEjk4FbEjuhK8ueoUE8tNLBhSwhsQ7S60onXV43vfjmrN/OC+Oc46zfAunZE47GJXZiSu0Evyr437CnLNuGdOaa4ugKq5eUEkI0LaPxuoO6aDeJtJSS6p/hQNsvA3V+ZUhJm0MSl9ATkk26YM+CBbCSOiFBqn+6Y78nbb+tZ9KwVa915tMeKTBN5LsFChbvsLdphvELwf8DEUcplv4IXk8AAAAASUVORK5CYII=',
                                fit: [100, 100],
                                alignment: 'left',
                            },
                            {
                                text: 'Relatório Remoto',
                                alignment: 'right',
                                color: "#009B45",
                                fontSize: 18,
                                bold: true
                            }
                        ]
                    },

                    {
                        marginTop: 17,
                        layout: 'noBorders',
                        table: {
                            headerRows: 1,
                            widths: ['*', '*'],
                            body: [
                                [{
                                    text: 'Objeto',
                                    color: '#999',
                                    fontSize: 12
                                }/*, {
                                    text: 'Proprietário',
                                    color: '#999',
                                    fontSize: 12
                                }*/],
                                [{
                                    text: relatorio && relatorio.data && relatorio.data.farm_name ? this.limitText(relatorio.data.farm_name, 23) : (relatorio.polygon ? this.limitText(relatorio.polygon.nome_propriede, 23) : 'Não cadastrado' ),
                                    color: '#000',
                                    fontSize: 16,
                                    bold: true
                                }/*, {
                                    text: relatorio && relatorio.data && relatorio.data.owner_name ? this.limitText(relatorio.data.owner_name, 23) : ( relatorio.isOwner ? this.limitText(relatorio.name, 23) : 'Não cadastrado' ),
                                    color: '#000',
                                    fontSize: 16,
                                    bold: true
                                }*/],
                            ]
                        }
                    },
                    /* ############ CABECALHO DO RELATORIO ####################### */


                    {
                        table: {
                            widths: ['auto'],
                            body: [[{
                                text: "________",
                                color: '#fff',
                                borderColor: ['#C7C7C7', '#C7C7C7', '#C7C7C7', '#C7C7C7']
                            }], [" "]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    relatorio.data.prices ? {
                        image: relatorio.farmImage,
                        width: 525,
                        height: 200
                    } : {},
                    {
                        marginTop: 10,
                        text: relatorio && relatorio.data && relatorio.data.distance && relatorio.data.nearest_urban_city ? 'Aprox. ' + Math.round(relatorio.data.distance.city) + ' Km do centro urbano de ' + relatorio.data.nearest_urban_city.name + ' - ' + relatorio.data.nearest_urban_city.state.toUpperCase() + ' e aprox. ' + Math.round(relatorio.data.distance.principal_city) + ' Km do centro da capital do estado' : '',
                        fontSize: 10,
                        color: '#1B1B1B'
                    },
                    {

                    },
                    {
                        marginTop: 20,
                        table: {
                            widths: ['*'],
                            body: [[{
                                text: "",
                                color: '#fff',
                                borderColor: ['#000', '#000', '#000', '#000']
                            }], [" "]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 2;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        table: {
                            widths: ['*', '*', '*'],
                            body: [
                                [{
                                    text: 'VALOR DE MERCADO',
                                    color: '#000',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'center',
                                }, {
                                    text: 'VALOR DE LIQUIDAÇÃO',
                                    color: '#000',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'center',
                                }, {
                                    text: 'VALOR DE LI. FORÇADA',
                                    color: '#000',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'center',
                                }],
                                [{
                                    columns: [
                                        { width: '*', text: '' },
                                        {
                                            width: 'auto',
                                            layout: 'noBorders',
                                            table: {
                                                body: [
                                                    [{
                                                        text: relatorio && relatorio.data || relatorio.valueEstimated ? 'R$' : '',
                                                        color: "#A9B1AD",
                                                        fontSize: 10,
                                                        bold: true,
                                                        width: 'auto',
                                                    }, {
                                                        text: relatorio && relatorio.data.prices ? Math.round(relatorio.data.prices[0].total_price).toLocaleString('pt-br') :  (relatorio.valueEstimated ? relatorio.valueEstimated.replace('R$', '') : 'Não cadastrado'),
                                                        width: 'auto',
                                                        fontSize: 14,
                                                        bold: true,
                                                        color: "#009B45",
                                                    }],
                                                ]
                                            }
                                        },
                                        { width: '*', text: '' },
                                    ]
                                }, {
                                    columns: [
                                        { width: '*', text: '' },
                                        {
                                            width: 'auto',
                                            layout: 'noBorders',
                                            table: {
                                                body: [
                                                    [{
                                                        text: relatorio && relatorio.data ? 'R$' : '',
                                                        color: "#A9B1AD",
                                                        fontSize: 10,
                                                        bold: true,
                                                        width: 'auto',
                                                    }, {
                                                        text: relatorio && relatorio.data.prices ? Math.round(relatorio.data.prices[0].clouseout_price).toLocaleString('pt-br') : 'Não cadastrado',
                                                        width: 'auto',
                                                        fontSize: 14,
                                                        bold: true,
                                                        color: "#009B45",
                                                    }],
                                                ]
                                            }
                                        },
                                        { width: '*', text: '' },
                                    ]
                                }, {
                                    columns: [
                                        { width: '*', text: '' },
                                        {
                                            width: 'auto',
                                            layout: 'noBorders',
                                            table: {
                                                body: [
                                                    [{
                                                        text: relatorio && relatorio.data ? 'R$' : '',
                                                        color: "#A9B1AD",
                                                        fontSize: 10,
                                                        bold: true,
                                                        width: 'auto',
                                                    }, {
                                                        text: relatorio && relatorio.data.prices ? Math.round(relatorio.data.prices[0].clouseout_forced_price).toLocaleString('pt-br') : 'Não cadastrado',
                                                        width: 'auto',
                                                        fontSize: 14,
                                                        bold: true,
                                                        color: "#009B45",
                                                    }],
                                                ]
                                            }
                                        },
                                        { width: '*', text: '' },
                                    ]
                                }],
                            ],
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 0;
                            },
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 0 : 1;
                            },
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#E3E3E3' : '#E3E3E3';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#E3E3E3' : '#E3E3E3   ';
                            },
                            // paddingLeft: function(i, node) { return 4; },
                            // paddingRight: function(i, node) { return 4; },
                            // paddingTop: function(i, node) { return 2; },
                            // paddingBottom: function(i, node) { return 2; }
                        },
                    },
                    {
                        marginTop: 10,
                        table: {
                            widths: ['*'],
                            body: [[{
                                text: "",
                                color: '#fff',
                                borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                            }], [""]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        marginTop: 25,
                        columns: [
                            {
                                text: 'Área (ha)',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                            {
                                text: 'Valor da Terra Nua',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                        ],
                    },
                    {
                        columnGap: 50,
                        columns: [
                            {
                                width: '45%',
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                        ],
                    },

                    {
                        marginTop: 10,
                        columns: [
                            {
                                text: relatorio.data && relatorio.data.area ? Math.round(relatorio.data.area).toLocaleString('pt-br') : (relatorio.area ? relatorio.area : 'Não cadastrado'),
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                            {
                                text: relatorio && relatorio.data.prices ? 'R$' + Math.round(relatorio.data.prices[0].hectare_price).toLocaleString('pt-br') + '/ha' : 'Não cadastrado',
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                        ],
                    },
                    

                    /* ############ AREA DAS PORCENTAGENS ################### */
                    {
                        marginTop: 22,
                        columns: [
                            {
                                text: 'Agricultura',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                            {
                                text: 'Pastagem',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                            {
                                text: 'Reflorestamento',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                            {
                                text: 'Vegetação Nativa',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                        ],
                    },

                    {
                        columnGap: 50,
                        columns: [
                            {
                                width: '45%',
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                        ],
                    },
                    {
                        marginTop: 10,
                        columns: [
                            {
                                text: relatorio.agriculture,
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                            {
                                text: relatorio.pasture,
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                            {
                                text: relatorio.reforestation,
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                            {
                                text: relatorio.nativeVegetation,
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                        ],
                    },
                    /* ############ AREA DAS PORCENTAGENS ################### */


                    /* ############ AREA DA MATRICULA ################### */
                    {
                        marginTop: 22,
                        columns: [
                            {
                                text: 'Matrícula',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                            {
                                text: 'Data Base',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                        ],
                    },
                    {
                        columnGap: 50,
                        columns: [
                            {
                                width: '45%',
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                        ],
                    },
                    {
                        marginTop: 10,
                        columns: [
                            {
                                text: relatorio && relatorio.data && relatorio.data.registration_number ? relatorio.data.registration_number : 'Não cadastrado',
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                            {
                                text: relatorio && relatorio.data && relatorio.data.register_date ? format(new Date(relatorio.data.register_date), 'dd/MM/yyyy') : 'Não cadastrado',
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                        ],
                    },
                    /* ############ AREA DA MATRICULA ################### */


                    /* ############ AREA DA ATIVIDADE PRINCIPAL ################### */
                    {
                        marginTop: 22,
                        columns: [
                            {
                                text: 'Atividade principal',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                            {
                                text: 'Safras produzidas por ano',
                                bold: true,
                                color: '#000',
                                fontSize: 12
                            },
                        ],
                    },
                    {
                        columnGap: 50,
                        columns: [
                            {
                                width: '45%',
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    body: [[{
                                        text: "",
                                        color: '#fff',
                                        borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                                    }], [""]]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 1;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0;
                                    },
                                }
                            },
                        ],
                    },
                    {
                        columns: [
                            {
                                text: relatorio.activityFirst ? relatorio.activityFirst : 'Não cadastrado',
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                            {
                                text: relatorio.vintagesPerYear ? relatorio.vintagesPerYear : 'Não cadastrado',
                                color: '#1B1B1B',
                                fontSize: 12
                            },
                        ],
                    },
                    /* ############ AREA DA MATRICULA ################### */


                    /* ############ CABECALHO DO RELATORIO ####################### */
                    {
                        pageBreak: 'before',
                        marginTop: -59,
                        columns: [
                            {
                                aligment: 'left',
                                table: {
                                        widths: ['auto'],
                                        body: [[{
                                            text: "___________________",
                                            color: '#fff',
                                            borderColor: ['#009B45', '#009B45', '#009B45', '#009B45']
                                        }], [" "]]
                                },
                                layout: {
                                    hLineWidth: function(i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 10;
                                    },
                                    vLineWidth: function(i, node) {
                                        return 0;
                                    },
                                }
                            }, {
                                marginLeft: 132,
                                aligment: 'right',
                                table: {
                                        widths: ['auto'],
                                        body: [[{
                                            text: "___________________",
                                            color: '#fff',
                                            borderColor: ['#009B45', '#009B45', '#009B45', '#009B45']
                                        }], [" "]]
                                },
                                layout: {
                                    hLineWidth: function(i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0 : 10;
                                    },
                                    vLineWidth: function(i, node) {
                                        return 0;
                                    },
                                }
                            }
                        ]
                    },
                    {
                        columns: [
                            {
                                image: 'data:image/png;base64,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',
                                fit: [100, 100],
                                alignment: 'left',
                            },
                            {
                                text: 'Relatório Remoto',
                                alignment: 'right',
                                color: "#009B45",
                                fontSize: 18,
                                bold: true
                            }
                        ]
                    },
                    {
                        marginTop: 17,
                        layout: 'noBorders',
                        table: {
                            headerRows: 1,
                            widths: ['*', '*'],
                            body: [
                                [{
                                    text: 'Objeto',
                                    color: '#999',
                                    fontSize: 12
                                }/*, {
                                    text: 'Proprietário',
                                    color: '#999',
                                    fontSize: 12
                                }*/],
                                [{
                                    text: relatorio && relatorio.data && relatorio.data.farm_name ? this.limitText(relatorio.data.farm_name, 23) : (relatorio.polygon ? this.limitText(relatorio.polygon.nome_propriede, 23) : 'Não cadastrado' ),
                                    color: '#000',
                                    fontSize: 16,
                                    bold: true
                                }/*, {
                                    text: relatorio && relatorio.data && relatorio.data.owner_name ? this.limitText(relatorio.data.owner_name, 23) : ( relatorio.isOwner ? this.limitText(relatorio.name, 23) : 'Não cadastrado' ),
                                    color: '#000',
                                    fontSize: 16,
                                    bold: true
                                }*/],
                            ]
                        }
                    },
                    /* ############ CABECALHO DO RELATORIO ####################### */


                    /* ############ AREA DA HIPOTECA E ALIENACAO FIDUCIARIA ################### */
                    {
                        marginTop: 26,
                        text: 'Hipoteca/Alienação fiduciária',
                        color: '#000',
                        fontSize: 12,
                        bold: true
                    },
                    {
                        table: {
                            widths: ['*'],
                            body: [[{
                                text: "",
                                color: '#fff',
                                borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                            }], [""]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        marginTop: 11,
                        text: relatorio.isMoetgage ? 'Possui.' : 'Não possui.',
                        fontSize: 12,
                        color: '#1B1B1B'
                    },
                    /* ############ AREA DA HIPOTECA E ALIENACAO FIDUCIARIA ################### */


                    /* ############ AREA DO SOLO E RELEVO ################### */
                    {
                        marginTop: 26,
                        text: 'Solo',
                        color: '#000',
                        fontSize: 12,
                        bold: true
                    },
                    {
                        table: {
                            widths: ['*'],
                            body: [[{
                                text: "",
                                color: '#fff',
                                borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                            }], [""]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        marginTop: 11,
                        text: relatorio.data && relatorio.data.ground_type && relatorio.data.ground_type.length > 0 ? this.formatPdf.validateSoils(relatorio.data.ground_type[0], relatorio.predominantSoils) : (relatorio.predominantSoils ? this.formatPdf.validateSoils(null, relatorio.predominantSoils) : 'Não cadastrado.'),
                        fontSize: 12,
                        color: '#1B1B1B'
                    },
                    /* ############ AREA DO SOLO E RELEVO ################### */


                    /* ############ AREA DO BIOMA ################### */
                    {
                        marginTop: 26,
                        text: 'Bioma',
                        color: '#000',
                        fontSize: 12,
                        bold: true
                    },
                    {
                        table: {
                            widths: ['*'],
                            body: [[{
                                text: "",
                                color: '#fff',
                                borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                            }], [""]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        marginTop: 11,
                        text: relatorio.data && relatorio.data.biome_type && relatorio.data.biome_type.length > 0 ? this.formatPdf.formatBiome(relatorio.data.biome_type[0]) : 'Não cadastrado.',
                        fontSize: 12,
                        color: '#1B1B1B'
                    },
                    /* ############ AREA DO BIOMA ################### */


                    /* ############ AREA DO CLIMA ################### */
                    {
                        marginTop: 26,
                        text: 'Clima',
                        color: '#000',
                        fontSize: 12,
                        bold: true
                    },
                    {
                        table: {
                            widths: ['*'],
                            body: [[{
                                text: "",
                                color: '#fff',
                                borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                            }], [""]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        marginTop: 11,
                        text: relatorio.data && relatorio.data.climate_type && relatorio.data.climate_type.length > 0 ? this.formatPdf.formatClimate(relatorio.data.climate_type[0]) : 'Não cadastrado.',
                        fontSize: 12,
                        color: '#1B1B1B'
                    },
                    /* ############ AREA DO CLIMA ################### */


                    /* ############ AREA DO OBSERVACOES ################### */
                    {
                        marginTop: 26,
                        text: 'Observações',
                        color: '#000',
                        fontSize: 12,
                        bold: true
                    },
                    {
                        table: {
                            widths: ['*'],
                            body: [[{
                                text: "",
                                color: '#fff',
                                borderColor: ['#e3e3e3', '#e3e3e3', '#e3e3e3', '#e3e3e3']
                            }], [""]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        marginTop: 11,
                        text: relatorio && relatorio.data && relatorio.data.overlap ? this.formatOverlap(relatorio.data.overlap) : 'Não cadastrado.',
                        fontSize: 12,
                        color: '#1B1B1B'
                    },
                    {
                        table: {
                            widths: ['auto'],
                            body: [[{
                                text: "________",
                                color: '#fff',
                                borderColor: ['#C7C7C7', '#C7C7C7', '#C7C7C7', '#C7C7C7']
                            }], [" "]]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0 : 1;
                            },
                            vLineWidth: function (i, node) {
                                return 0;
                            },
                        }
                    },
                    {
                        text: "*O Relatório Remoto da matrícula é gerado pelos algoritmos do TerraLogs com base em informações públicas e autodeclaradas.",
                        fontSize: 8,
                        color: '#1B1B1B'
                    }
                ],
                footer: {
                    columns: [
                         {
                            text: "www.terralogs.com.br",
                            fontSize: 10,
                            color: '#1B1B1B',
                            alignment: 'center',
                            bold: true
                         }
                    ]
                }
            };
            /* ############ AREA DO OBSERVACOES ################### */

            pdfMake.createPdf(dd).download('Relatorio-Remoto-Terralogs.pdf', (result) => resolve(result));
        });
    }

    private formatOverlap(overlap) {
        let texto = '';
        if(overlap.conservation_area && overlap.indigenous_land && overlap.legal_amazon && overlap.quilombola && overlap.settlement) {
            texto = 'Não cadastrado.';
        } else {
            texto = 'Não possui sobreposição com';
            let isFirst = true;
            if (!overlap.conservation_area) {
                isFirst = false;
                texto += ' Áreas de Conservação';
            }
            if (!overlap.indigenous_land) {
                if (!isFirst) texto += ', ';

                isFirst = false;
                texto += ' Terras Indígenas';
            }
            if (!overlap.legal_amazon) {
                if (!isFirst) texto += ', ';

                isFirst = false;
                texto += ' Amazônia Legal';
            }
            if (!overlap.quilombola) {
                if (!isFirst) texto += ', ';

                isFirst = false;
                texto += ' Quilombolas';
            }
            if (!overlap.settlement) {
                if (!isFirst) texto += ', ';

                texto += ' Assentamentos';
            }
            texto += '.';
        }
        return texto;
    }

    private limitText(text: string, limit: number) {
        if (text) {
          if (text.length > limit) {
            return text.substring(0, limit) + '...';
        } else {
            return text;
        }
      } else  {
          return '';
      }
    }
}
